export default __webpack_public_path__ + "static/timeline-mask-mobile-50781eec73666f5adbf7df9063deafc6.svg";